import React from 'react'
import Login from './Login'
import LoginLayout from './LoginLayout'
import './Login.scss'

export interface LoginViewProps {
  sessionId: string | null
}

const LoginView = (props: LoginViewProps) => {
  return (
    <LoginLayout>
      <Login sessionId={props.sessionId} />
    </LoginLayout>
  )
}

export default LoginView
